export default __webpack_public_path__ + "static/media/자기계발.e0f013d2.png";